import { render, staticRenderFns } from "./HrDossierDestory.vue?vue&type=template&id=e573b254&scoped=true&"
import script from "./HrDossierDestory.vue?vue&type=script&lang=js&"
export * from "./HrDossierDestory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e573b254",
  null
  
)

export default component.exports